import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function MobileShell({ children, page, showBack = false, backTo, className = '' }) {
  const navigate = useNavigate();
  return (
    <main className={`mobile-stage ${className}`}>
      {showBack && (
        <button className="mobile-back" type="button" onClick={() => navigate(backTo ?? -1)} aria-label="返回">
          <ArrowLeft size={22} />
        </button>
      )}
      {page && <div className="mobile-page-label">{page}</div>}
      {children}
    </main>
  );
}

export function BrandFooter() {
  return <div className="brand-footer" aria-hidden="true" />;
}
